export default {
  enabled: process.env.NEXT_PUBLIC_SENTRY_ENABLED,
}
